export enum CounterSort {
	CurrentYear,
	NextYear,
	RTT
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/situationDesAbsences/tableaux/situationManager/situationManager.model.ts